import { Button } from "@/components/ui/button";
import { FileSpreadsheet, FileText } from "lucide-react";
import { toast } from "sonner";

export default function ExportButtons({ endpoint, label }) {
  const baseUrl = process.env.REACT_APP_BACKEND_URL;

  const handleExport = async (format) => {
    try {
      const url = `${baseUrl}/api/export/${endpoint}?format=${format}`;
      const res = await fetch(url, { credentials: "include" });
      if (!res.ok) throw new Error("Export failed");
      const blob = await res.blob();
      const ext = format === "pdf" ? "pdf" : "xlsx";
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `${endpoint}_report.${ext}`;
      a.click();
      URL.revokeObjectURL(a.href);
      toast.success(`${label} exported as ${format.toUpperCase()}`);
    } catch {
      toast.error(`Failed to export ${label}`);
    }
  };

  return (
    <div className="flex items-center gap-1">
      <Button size="sm" variant="outline" className="h-7 text-xs gap-1" onClick={() => handleExport("excel")} data-testid={`export-${endpoint}-excel`}>
        <FileSpreadsheet size={13} /> Excel
      </Button>
      <Button size="sm" variant="outline" className="h-7 text-xs gap-1" onClick={() => handleExport("pdf")} data-testid={`export-${endpoint}-pdf`}>
        <FileText size={13} /> PDF
      </Button>
    </div>
  );
}
